import Blazy from 'blazy';
import customSelect from 'custom-select';

(function() {

	const Helper = function() {
        return {
        	blazy: blazy,
        	isInView: isInView,
        	rwd: rwd,
        	thisIndex: thisIndex,
            onloadOpenStory: onloadOpenStory
        };
    };

	const onloadOpenStory = function() {
        var activeStory = document.getElementById('peopleSwiper').getAttribute('data-active');
        if (activeStory === null) {
            return;
        }

        var btns = document.querySelectorAll('#peopleSwiper a.o-btn[data-popup="'+activeStory+'"]');
        if (btns.length > 0) {
            btns[0].click();
        }
    };

	const isInView = function(el) {
		var bottomOfWindow = (window.pageYOffset || window.scrollY) + window.innerHeight;

		if ( el.getBoundingClientRect().top + (window.pageYOffset || window.scrollY) < bottomOfWindow ) {
			return true;
		}
	};

	const thisIndex = function(elm) {
        let nodes = elm.parentNode.childNodes, node, i = 0, count = 0;

        while( (node = nodes.item(i++)) && node != elm ) {
            if( node.nodeType == 1 ) count++;
        }

        return count;
    };

	const blazy = function() {

		var bLazy = new Blazy({
			success: function(element){
			    setTimeout(function(){
					var parent = element.parentNode,
						grandpa = element.parentNode.parentNode;

					parent.className += ' is-loaded';
					grandpa.className += ' is-loaded';
					//parent.parentNode.className = parent.parentNode.className.replace(/\bis-loading\b/,'');
			    }, 200);
	        }
	   });
	};

	const rwd = function() {
	    var top = document.getElementById('top');

        var detach = function(node, target) {
        	var parent = node.parentNode;
        	var next = node.nextSibling;
        	if (!parent) { return; }

        	parent.removeChild(node);	// Detach node from DOM.
        	target.append(node, next);	// Append
        };

        var joinStatus = false,
            joinBtn = document.getElementById('joinBtn'),
            joinBtnInNav = document.getElementsByClassName('js-joinBtn')[0],
            joinAction = function() {

			var ww = window.innerWidth;

			if (ww <= 1024 && joinStatus !== true) {
				detach( joinBtn, top );
				joinStatus = true;
			}

			if (ww > 1024 && joinStatus === true) {
				detach( joinBtn, joinBtnInNav );
				joinStatus = false;
			}
		};

		//joinAction();
		//window.addEventListener('resize', joinAction);

	};

	// Select
    (function() {

        const select = document.querySelectorAll("select"),
            init = function() {

                const cstSel = customSelect(select);

                for (let i = 0; i < select.length; i ++) {
                    cstSel[i].container.addEventListener('custom-select:open', (e) => {

                        if (!e.target.parentNode.classList.contains('c-lang')) {
                            e.target.parentNode.parentNode.style.position = 'relative';
                            e.target.parentNode.parentNode.style.zIndex = '5';
                        }
                    });

                    cstSel[i].container.addEventListener('custom-select:close', (e) => {
                        if (!e.target.parentNode.classList.contains('c-lang')) {
                            e.target.parentNode.parentNode.removeAttribute('style');
                        }
                    });

                    cstSel[i].select.addEventListener('change', (e) => {
                        if (e.target.parentNode.parentNode.classList.contains('c-lang')) {

                            let value = e.target.value;

                            window.open(value, '_self');
                        }
                    });
                }
            };

        select ? init() : false;

    })();

	ctme.Helper = new Helper();

}(window.ctme = window.ctme || {}));

